import { useEffect, useState } from 'react'
import useBriefContext from '../../../../Hooks/Brief/useBriefContext'
import isDirectEnquiryBrief from '../../../../Logic/Form/Sequences/DirectEnquiry/isDirectEnquiryBrief'
import MessagingAside from './Aside'
import MessagingModal from './Modal'

const LeadFeedMessaging = (): JSX.Element | null => {
  const { brief, showBizLayout: willShowBizLayout } = useBriefContext()
  const isDirectEnquiry = isDirectEnquiryBrief(brief)
  const [showBizLayout, setShowBizLayout] = useState(willShowBizLayout)
  const [fadeOut, setFadeOut] = useState(false)
  const initFadeOut = !showBizLayout && willShowBizLayout
  const initFadeIn = showBizLayout && !willShowBizLayout

  useEffect(() => {
    if (initFadeOut && !fadeOut) {
      setFadeOut(true)
      const timer = setTimeout(() => {
        setFadeOut(false)
        setShowBizLayout(true)
      }, 1000)
      return () => clearTimeout(timer)
    }

    if (initFadeIn) {
      // no async changes required; the transition is pure CSS
      setFadeOut(false)
      setShowBizLayout(false)
    }
  }, [willShowBizLayout])

  if (showBizLayout) return null

  return (
    <>
      <MessagingAside isDirectEnquiry={isDirectEnquiry} triggerFadeOut={fadeOut} />
      <MessagingModal isDirectEnquiry={isDirectEnquiry} triggerFadeOut={fadeOut} />
    </>
  )
}

export default LeadFeedMessaging
